module.exports = __webpack_public_path__ + "img/Strandkorb.66fc0758.jpg";